import React from 'react';
import { Button } from 'antd';
import TableExport from '../../../components/global/TableExport/TableExport';
import { ColumnType } from 'antd/lib/table';

interface TableRequestListItemsExportProps<T> {
  title?: string;
  dataSource: T[];
  columns: ColumnType<T>[];
}

const TableRequestListItemsExport = <T extends object>({
  title,
  dataSource,
  columns,
}: TableRequestListItemsExportProps<T>): React.ReactElement => {
  return (
    <TableExport
      columns={columns}
      dataSource={dataSource}
      fileName={`${title}.xlsx`}
      sheetName="Request List Statistics"
    >
      <Button>Export</Button>
    </TableExport>
  );
};

export default TableRequestListItemsExport;
